// @ts-nocheck
import StoreCreateAccountReducer, {
    StoreCreateAccountActions,
} from "@store/Framework/Store/Store/Pages/CreateAccount/StoreCreateAccountReducer";
import StoreOrderHistoryReducer, {
    StoreOrderHistoryActions,
} from "@store/Framework/Store/Store/Pages/OrderHistory/StoreOrderHistoryReducer";
import { combineReducers } from "redux";

const pagesReducers = {
    orderHistory: StoreOrderHistoryReducer,
    createAccount: StoreCreateAccountReducer,
};

export type StorePagesActions = StoreOrderHistoryActions | StoreCreateAccountActions;
export default combineReducers(pagesReducers);
